<article>
  <opac-skeleton class="hide-tablet" style="width: 120px; height: 14px; margin-bottom: 32px"></opac-skeleton>
  <section>
    <div *ngFor="let i of [1, 2]">
      <opac-skeleton></opac-skeleton>
      <opac-skeleton class="hide-tablet"></opac-skeleton>
      <opac-skeleton></opac-skeleton>
    </div>
  </section>
</article>
